import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import './assets/less/index.less';
import * as echarts from 'echarts';

import img from './lib/img'
import utils from "./lib/utils";
import 'fast-text-encoding'; 
import { createPinia, PiniaVuePlugin } from 'pinia'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
const pinia = createPinia()

Vue.prototype.$echarts = function (el) {
  return echarts.init(el)
}
Vue.prototype.$images = img
Vue.config.productionTip = false;
Vue.use(iView);
Vue.use(utils)
Vue.use(PiniaVuePlugin)
Vue.use(ElementUI);

new Vue({
  router,
  pinia,
  render: h => h(App)
}).$mount('#app')
